<template>
  <div>
    <v-toolbar flat>
      <v-toolbar-title>
        Supporttyper
      </v-toolbar-title>
      <v-spacer />
      <v-text-field
        v-model="search"
        solo
        hide-details
        dense
        clearable
        class="mr-3"
        append-icon="mdi-magnify"
      />
      <v-spacer />
      <v-menu
        v-model="addMenu"
        left
        :close-on-content-click="false"
        min-width="500"
      >
        <template #activator="{ attrs, on }">
          <v-btn
            v-bind="attrs"
            v-on="on"
          >
            Ny type
            <v-icon right> mdi-plus </v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            Ny type
          </v-card-title>
          <v-card-text>
            <v-form
              ref="addForm"
              v-model="valid"
            >
              <v-text-field
                v-model="newItem.title"
                label="Navn"
                autofocus
                :rules="[ v => !!v || 'Udfyld et navn' ]"
                outlined
              />
              <v-text-field
                v-model.number="newItem.slaValue"
                label="SLA værdi"
                :rules="[ v => !!v || 'SLA værdi skal udfyldes' ]"
                outlined
              />
              <v-autocomplete
                v-model="newItem.slaUnit"
                :items="slaUnits"
                :rules="[ v => !!v || 'SLA enhed skal udfyldes' ]"
                label="SLA enhed"
                outlined
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="onCloseAddMenu"
            >
              {{ $t('common.cancel') }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="!valid"
              :loading="creating"
              @click="create"
            >
              Opret
              <v-icon right> mdi-plus </v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-toolbar>
    <v-data-table
      :items="types"
      :headers="headers"
      :loading="loading"
      :search="search"
      sort-by="sortOrder"
      sort-desc
    >
      <template #[`item.actions`]="{ item }">
        <v-btn small @click="onEditItem(item)">
          <v-icon>mdi-pencil-outline</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog
      v-model="editDialog"
      width="800"
    >
      <v-card>
        <v-card-title>
          Rediger
        </v-card-title>
        <v-card-text>
          <v-form
            v-if="editItem"
            ref="editForm"
            v-model="editForm"
          >
            <v-text-field
              v-model="editItem.title"
              label="Navn"
              autofocus
              :rules="[ v => !!v || 'Udfyld et navn' ]"
              outlined
            />
            <v-text-field
              v-model.number="editItem.slaValue"
              label="SLA værdi"
              :rules="[ v => !!v || 'SLA værdi skal udfyldes' ]"
              outlined
            />
            <v-autocomplete
              v-model="editItem.slaUnit"
              :items="slaUnits"
              :rules="[ v => !!v || 'SLA enhed skal udfyldes' ]"
              label="SLA enhed"
              outlined
            />
            <v-text-field
              v-model.number="editItem.sortOrder"
              label="Sortering"
              outlined
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-menu
            width="500"
          >
            <template #activator="{ attrs, on }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                color="error"
                text
              >
                Slet
                <v-icon right>
                  mdi-delete-outline
                </v-icon>
              </v-btn>
            </template>

            <v-card>
              <v-card-title>
                Bekræft sletning
              </v-card-title>
              <v-card-text>
                Er du sikker på du vil slette?
              </v-card-text>
              <v-card-actions>
                <v-btn text>
                  {{ $t('common.cancel') }}
                </v-btn>
                <v-spacer />
                <v-btn
                  :loading="deleting"
                  @click="deleteItem(editItem.id)"
                >
                  Ja, slet
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
          <v-spacer />

          <v-btn :loading="saving" @click="saveItem">
            {{ $t('common.save') }}
            <v-icon right> mdi-content-save-outline </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const baseUrl = 'support-ticket-categories';

export default {
  name: 'CustomerSupportTicketCategoriesComponent',
  data() {
    return {
      creating: false,
      loading: true,
      newItem: {},
      addMenu: false,
      saving: false,
      deleting: false,
      search: '',
      valid: false,
      editItem: null,
      editForm: false,
      editDialog: false,
      types: [],
      slaUnits: [ 'Minutes', 'Hours', 'WorkingHours', 'Days' ],
      headers: [
        { text: 'Navn', value: 'title', width: '50%' },
        { text: 'SLA værdi', value: 'slaValue' },
        { text: 'SLA enhed', value: 'slaUnit' },
        { text: 'Sortering', value: 'sortOrder' },
        { text: 'Actions', value: 'actions', align: 'right', sortable: false }
      ],
    }
  },
  mounted() {
    this.getItems();
  },
  watch: {
    editDialog(value) {
      if (!value) {
        this.editItem = null;
        this.$refs.editForm.resetValidation();
      }
    }
  },
  methods: {
    create: async function() {
      this.creating = true;

      try {
        const model = {
          ...this.newItem,
          customerId: this.$route.params.customerId
        };

        const { data } = await this.$api.post(baseUrl, model);

        if (!data.success) throw data.errors?.at(0)?.message ?? data.message ?? 'Something went wrong';

        this.$notifier.showSuccess({ message: 'Supporttype oprettet' });
        this.getItems();
        this.onCloseAddMenu();
      } catch (error) {
        console.error(error);
        this.$notifier.showError({});
      } finally {
        this.creating = false;
      }
    },
    onEditItem: function(item) {
      this.editItem = JSON.parse(JSON.stringify(item));
      this.editDialog = true;
    },
    getItems: async function() {
      this.loading = true;

      try {
        const { data } = await this.$api.get(baseUrl, {
          params: {
            customerId: this.$route.params.customerId
          }
        });

        this.types = data;
      } catch (error) {
        console.error(error);
        this.$notifier.showError({});
      } finally {
        this.loading = false;
      }
    },
    saveItem: async function() {      
      this.saving = true;

      const { id, title, slaUnit, slaValue, sortOrder } = this.editItem;

      const model = {
        title,
        slaUnit,
        slaValue,
        sortOrder
      };

      try {
        const { data } = await this.$api.put(`${baseUrl}/${id}`, model);

        if (!data.success) throw data.errors?.at(0)?.message ?? data.message ?? 'Something went wrong';

        this.$notifier.showSuccess({ message: 'Supporttype opdateret' });
        this.getItems();
        this.editDialog = false;
      } catch (error) {
        console.error(error);
        this.$notifier.showError({});
      } finally {
        this.saving = false;
      }
    },
    deleteItem: async function(id) {
      this.deleting = true;

      try {
        const { data } = await this.$api.delete(`${baseUrl}/${id}`);

        if (!data.success) throw data.errors?.at(0)?.message ?? data.message ?? 'Something went wrong';

        this.$notifier.showSuccess({ message: 'Supporttype slettet' });
        this.getItems();
        this.editDialog = false;
      } catch (error) {
        console.error(error);
        this.$notifier.showError({ message: error });
      } finally {
        this.deleting = false;
      }
    },
    onCloseAddMenu() {
      this.$refs.addForm.reset();
      this.addMenu = false;
    }
  }
}
</script>